// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46ae428f","239":"66f3c4be","453":"d8797c4b","455":"b481bdb8"}[chunkId] + ".chunk.js";
};